import styled from "styled-components"

export const Container = styled.nav`
  position: fixed;
  top: 175px;
  right: 0;
  background: white;
  padding: 10px;
  padding-bottom: 0;
  -webkit-border-radius: 25px;
  border-radius: var(--border-radius);
  z-index: 2;
  box-shadow: var(--box-shadow);
  max-width: 100px;

  a {
    width: 100%;
    margin-bottom: var(--gapXS);
    margin-top: 5px;
    text-decoration: none;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    &:hover {
      span {
        background: var(--clr-dark-purple);
      }
    }
  }
  span {
    display: inline-block;
    font-size: 12px;
    background: var(--clr-purple);
    color: white;
    padding: 5px 10px;
    margin-top: 5px;
    border-radius: var(--border-radius);
    min-width: 100%;
  }

  @media (max-width: 992px) {
    display: none;
    visibility: hidden;
  }
`

export const ImgContainer = styled.div`
  background: #e7e7e7;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  padding: 5px;
  min-width: 50px;
  min-height: 50px;
  max-width: 50px;
  max-height: 50px;
`
